import { useState, useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import CreateTransactionModal from "./createTransaction";
import {
  deleteTransaction,
  getFutureTransaction,
  getTransaction,
} from "../../../../../services/transaction";
import CustomDropdown from "../../../../../components/Dropdown";
import {
  formatNumber,
  getBreadcrumbLabelsByAssetType,
  getDropdownLabelsByAssetType,
  getTabLabelsByAssetType,
  HorizontalTabButtons,
  truncateText,
  truncateToTwoDecimals,
} from "../../../../../utility/helper";
import ConfirmDialog from "../../../../../components/ConfirmDialog";
import {
  clearSelectedAsset,
  fetchUserAssets,
  setSelectedAsset,
} from "../../../../../redux/slices/userAssetsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import AssetGuardedActionButton from "../../../../../components/AddTransactionButton";
import MovementComponent from "./cashComponents/movement";
import { handleErrorRedirect } from "../../../../../utility/errorRedirect";
import Breadcrumb from "../../../../../components/Breadcrumb";
import CashSkeleton from "./cashComponents/cashSkeleton";
const ViewTransaction = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [type, setType] = useState("");
  const [viewTransaction, setViewTransaction] = useState([]);
  const [viewFutureTransaction, setViewFutureTransaction] = useState([]);
  const [loading, setLoading] = useState(false);
  const [transactionLoading, setTransactionLoading] = useState(false);

  const [limit, setLimit] = useState(20);
  const [page, setPage] = useState(0);
  const [singleTransactionData, setSingleTransactionData] = useState({});
  const [actionTypes, setActionTypes] = useState("Create");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogConfig, setDialogConfig] = useState({});
  const [selectedButton, setSelectedButton] = useState("Movements");

  const userAssets = useSelector((state) => state.userAssets.data);
  const { selectedAsset, userAssetLoading } = useSelector(
    (state) => state.userAssets
  );
  const toast = useRef(null);
  const dropdownOptions = getDropdownLabelsByAssetType("1");
  const dispatch = useDispatch();
  const accessToken = JSON.parse(localStorage.getItem("access_token"));
  const location = useLocation();
  const id = location?.state?.id || null;
  const navigate = useNavigate();
  const tabOptions = getTabLabelsByAssetType("1");
  const breadcrumbItems = getBreadcrumbLabelsByAssetType("Cash");
  const { currency } = useSelector((state) => state.user);

  useEffect(() => {
    if (selectedAsset) {
      GetTransactionData();
      GetFutureTransactionData();
    }
  }, [selectedAsset, page]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    dispatch(fetchUserAssets({ assetTypeId: 1, selectedAssetId: id })).then(
      (resultAction) => {
        if (fetchUserAssets.rejected.match(resultAction)) {
          const status = resultAction?.payload?.status;
          handleErrorRedirect(status, navigate);
        }
      }
    );
    return () => {
      dispatch(clearSelectedAsset());
    };
  }, [dispatch, id]);

  const openConfirmDialog = (config) => {
    setDialogConfig(config);
    setIsDialogOpen(true);
  };

  const confirmTransactionDelete = (transactionId) => {
    openConfirmDialog({
      title: "Confirm Delete",
      message: "Are you sure you want to delete this transaction?",
      confirmText: "Delete",
      cancelText: "Cancel",
      cancelClass:
        "ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium border dark:border-gray-300 border-info rounded-md bg-transparent text-info dark:text-grey rounded-md focus:outline-none",
      confirmClass:
        "ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium dark:text-black dark:button-primary-gradient rounded-md bg-lightPrimary text-white rounded-md focus:outline-none",
      onConfirm: () => handleTransactionDelete(transactionId),
    });
  };

  const handleTransactionDelete = async (user) => {
    try {
      const accessToken = JSON.parse(localStorage.getItem("access_token"));
      const response = await deleteTransaction(accessToken, user?.id);
      console.log(response, "res");
      
      if (response?.data?.status === true) {
        dispatch(fetchUserAssets({ assetTypeId: 1, selectedAssetId: id }));
        GetTransactionData();
        GetFutureTransactionData();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: "transaction deleted successfully",
          life: 3000,
        });
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err?.response?.data?.message || err?.message || "delete failed",
        life: 3000,
      });
    }
  };

  const GetTransactionData = async () => {
    setTransactionLoading(true);
    try {
      const response = await getTransaction(
        selectedAsset.id,
        1,
        page * limit,
        limit,
        "All",
        accessToken
      );
      if (response.status === 200) {
        setViewTransaction(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setTransactionLoading(false);
    }
  };

  const GetFutureTransactionData = async () => {
    setLoading(true);
    try {
      const response = await getFutureTransaction(
        selectedAsset.id,
        page,
        limit,
        "All",
        1,
        accessToken
      );
      if (response.status === 200) {
        setViewFutureTransaction(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setLoading(false);
    }
  };

  const handleOptionSelect = (option, actionTypes, data) => {
    setModalVisible(true);
    setType(option);
    setActionTypes(actionTypes);
    setSingleTransactionData(data);
  };

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog
        isOpen={isDialogOpen}
        setIsOpen={setIsDialogOpen}
        {...dialogConfig}
      />
      <div className="">
        {/* <Breadcrumb items={breadcrumbItems} className="md:ml-5 mb-2" /> */}
        <div className="font-bold flex items-center flex-row justify-between px-4">
          <HorizontalTabButtons
            buttons={tabOptions}
            selected={selectedButton}
            onSelect={setSelectedButton}
          />
          <AssetGuardedActionButton
            userAssets={userAssets}
            onOptionSelect={handleOptionSelect}
            dropdownOptions={dropdownOptions}
            truncateText={truncateText}
            setIsDialogOpen={setIsDialogOpen}
            openConfirmDialog={openConfirmDialog}
            navigate={navigate}
            navigatePath="/my-view"
            assetsName={"Cash"}
          />
        </div>

        <div className="border border-lightPrimary/40 dark:border-info/40 pt-2 pb-4 px-4 p mx-4 my-3 bg-white dark:bg-card-custom-radials bg-[length:100%_200%]">
          <div className="text-gray-400">
            <CustomDropdown
              options={userAssets}
              name={selectedAsset ? selectedAsset?.name : "Select Asset"}
              assetId={selectedAsset ? selectedAsset?.id : "Select Asset"}
              onOptionSelect={(option) => dispatch(setSelectedAsset(option))}
              returnFullObject={true}
              truncateText={truncateText}
              disabled={!selectedAsset || !selectedAsset.name}
              size={19}
              className="inline-flex whitespace-nowrap disabled:cursor-not-allowed disabled:dark:opacity-75 disabled:border-none justify-center px-1 py-1.5  items-center gap-1 text-[0.65rem] font-medium bg-transparent rounded-md text-lightPrimary dark:text-white border border-transparent hover:border-dark"
            />
          </div>
          {transactionLoading || userAssetLoading  ? (
            <CashSkeleton />
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {/* <div className="ml-1 text-2xl text-lightPrimary dark:text-primary-gradient break-all">
              {viewTransaction?.asset_name ? viewTransaction.asset_name : "--"}
            </div> */}
              <div className="space-y-7 text-info dark:text-grey text-sm">
                <div className="flex items-baseline gap-4 w-full max-w-[24rem]">
                  <span className="ml-1 whitespace-nowrap">Value:</span>
                  <span className="text-2xl text-lightPrimary dark:text-primary-gradient break-anywhere font-medium">
                    {formatNumber(
                      viewTransaction?.remaining_balance
                        ? viewTransaction?.remaining_balance
                        : 0
                    )}{" "}
                    {currency ? currency : ""}
                  </span>
                </div>
              </div>

              <div className="space-y-2 text-sm text-info dark:text-grey">
                <div className="flex items-baseline gap-4 w-full max-w-[24rem]">
                  <span className="whitespace-nowrap">IN/OUT:</span>
                  <span className="text-2xl text-lightPrimary dark:text-primary-gradient break-anywhere font-medium">
                    {formatNumber(
                      truncateToTwoDecimals(
                        (viewTransaction?.total_in ?? 0) -
                          (viewTransaction?.total_out ?? 0)
                      )
                    )}{" "}
                    {currency ? currency : ""}
                  </span>
                </div>
              </div>

              <div className="grid grid-col-2 text-sm text-info dark:text-grey">
                <div className="space-y-3 w-full max-w-[25rem]">
                  <div className="flex items-baseline gap-12">
                    <span className="whitespace-nowrap">IN:</span>
                    <span className="text-lightPrimary text-2xl dark:text-primary-gradient break-anywhere font-medium">
                      {formatNumber(
                        (viewTransaction?.total_in
                          ? viewTransaction.total_in
                          : 0
                        ).toFixed(2)
                      )}{" "}
                      {currency ? currency : ""}
                    </span>
                  </div>
                  <div className="flex items-baseline gap-4 ">
                    <span className="whitespace-nowrap">Income:</span>
                    <span className="text-lightPrimary text-2xl dark:text-primary-gradient break-anywhere font-medium">
                      {formatNumber(
                        (viewTransaction?.total_income
                          ? viewTransaction.total_income
                          : 0
                        ).toFixed(2)
                      )}{" "}
                      {currency ? currency : ""}
                    </span>
                  </div>
                </div>
              </div>
              <div className="grid grid-col-2 text-sm text-info dark:text-grey">
                <div className="space-y-3 w-full max-w-[25rem]">
                  <div className="flex items-baseline gap-10">
                    <span className="whitespace-nowrap">OUT:</span>
                    <span className="text-expense text-2xl dark:text-warning font-medium break-anywhere">
                      {formatNumber(
                        viewTransaction?.total_out
                          ? viewTransaction?.total_out
                          : 0
                      )}{" "}
                      {currency ? currency : ""}
                    </span>
                  </div>
                  <div className="flex items-baseline gap-4">
                    <span className="whitespace-nowrap">Expense:</span>
                    <span className="text-expense text-2xl dark:text-warning break-anywhere font-medium">
                      {formatNumber(
                        viewTransaction?.total_expense
                          ? viewTransaction?.total_expense
                          : 0
                      )}{" "}
                      {currency ? currency : ""}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="mt-8 mx-4 bg-white dark:bg-card-custom-radial">
          {selectedButton === "Movements" && (
            <MovementComponent
              confirmDelete={confirmTransactionDelete}
              handleOptionSelect={handleOptionSelect}
              viewTransaction={viewTransaction}
              viewFutureTransaction={viewFutureTransaction}
              setLimit={setLimit}
              limit={limit}
              setPage={setPage}
              page={page}
              userAssetLoading={userAssetLoading}
              selectedAsset={selectedAsset}
            />
          )}
        </div>
        <CreateTransactionModal
          visible={modalVisible}
          singleTransactionData={singleTransactionData}
          actionTypes={actionTypes}
          fetchTransactionData={GetTransactionData}
          fetchFutureTransactionData={GetFutureTransactionData}
          viewTransaction={viewTransaction}
          onHide={() => {
            setModalVisible(false);
          }}
          SelectType={type}
          toast={toast}
          loading={loading}
          setLoading={setLoading}
          assetName={selectedAsset}
        />
      </div>
    </>
  );
};

export default ViewTransaction;
